import { ConstraintComparison, ConstraintTarget, ConstraintTypes } from "../../constants/constraints";
import uniqueId from "../../utils/uniqueId";

export default dep => {
  return {
    id: uniqueId(),
    constraintType: ConstraintTypes.Relative,
    subject: dep.successor,
    subjectTarget: ConstraintTarget.Start,
    object: dep.predecessor,
    objectTarget: dep.addToEnd ? ConstraintTarget.End : ConstraintTarget.Start,
    comparison: ConstraintComparison.Equal,
    offset: dep.offset
  };
};
